/**
 * Utilidades para manejo de AWBs
 * Formato: 123-45678900 (3 dígitos, guion, 8 dígitos = 11 dígitos total)
 */

/**
 * Limpiar AWB: quitar guiones y espacios, dejar solo dígitos
 * @param {string} awb - AWB con o sin formato
 * @returns {string} AWB limpio (solo dígitos)
 */
export const cleanAwb = (awb) => {
  if (!awb) return '';
  return awb.replace(/[-\s]/g, '');
};

/**
 * Validar formato AWB (debe tener 11 dígitos)
 * @param {string} awb - AWB a validar
 * @returns {boolean} True si es válido
 */
export const validateAwb = (awb) => {
  const clean = cleanAwb(awb);
  return /^\d{11}$/.test(clean);
};

/**
 * Formatear AWB: 12345678900 -> 123-45678900
 * @param {string} awb - AWB sin formato o con formato
 * @returns {string} AWB formateado (123-45678900)
 */
export const formatAwb = (awb) => {
  if (!awb) return '';
  
  const clean = cleanAwb(awb);
  
  // Si no tiene 11 dígitos, retornar tal cual
  if (clean.length !== 11) {
    return awb;
  }
  
  // Formatear: primeros 3 dígitos, guion, últimos 8 dígitos
  return `${clean.substring(0, 3)}-${clean.substring(3)}`;
};

/**
 * Parsear AWB: 123-45678900 -> 12345678900
 * (igual que clean, pero más semántico)
 * @param {string} awb - AWB con formato
 * @returns {string} AWB sin formato (solo dígitos)
 */
export const parseAwb = (awb) => {
  return cleanAwb(awb);
};

/**
 * Normalizar AWB: limpia y valida
 * @param {string} awb - AWB a normalizar
 * @returns {string|null} AWB normalizado (solo dígitos) o null si es inválido
 */
export const normalizeAwb = (awb) => {
  const clean = cleanAwb(awb);
  return validateAwb(clean) ? clean : null;
};

/**
 * Formatear AWB mientras el usuario escribe (auto-formato)
 * @param {string} value - Valor actual del input
 * @returns {string} Valor formateado
 */
export const formatAwbOnInput = (value) => {
  // Remover todo excepto dígitos
  const digits = value.replace(/\D/g, '');
  
  // Limitar a 11 dígitos
  const limited = digits.substring(0, 11);
  
  // Si tiene más de 3 dígitos, agregar guion después del tercero
  if (limited.length > 3) {
    return `${limited.substring(0, 3)}-${limited.substring(3)}`;
  }
  
  return limited;
};


